import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useStore } from 'vuex';
import { computed, onMounted, ref, watch } from 'vue';
export default {
  __name: 'hamburger',
  setup: function setup(__props) {
    var store = useStore();

    var toggleClick = function toggleClick() {
      store.commit('app/changeSiderType');
    };

    var icons = computed(function () {
      return store.getters.siderType ? 'hamburger-opened' : 'hamburger-closed';
    });
    var widthScreen = ref(); // 根据页面宽度决定是否收缩侧边导航

    onMounted(function () {
      setTimeout(function () {
        window.onresize = function () {
          widthScreen.value = document.body.offsetWidth;
        };
      }, 500);
    });
    watch(function () {
      return widthScreen.value;
    }, function (v1, v2) {
      if (v2 <= 866) {
        if (store.getters.siderType) {
          toggleClick();
        }
      }
    }, {
      deep: true // 深度监听的参数

    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");

      return _openBlock(), _createElementBlock("div", {
        class: "hamburger-container",
        onClick: toggleClick,
        id: "hamburger"
      }, [_createVNode(_component_svg_icon, {
        icon: _unref(icons)
      }, null, 8, ["icon"])]);
    };
  }
};